import Api from "@root/components/api";

export default class PayMutation {

}